var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(_vm.$store.state.systemApp.site_state == 2)?_c('div',{staticClass:"maintain"},[_c('p',[_vm._v(_vm._s(_vm.$store.state.systemApp.repair_tips))])]):_vm._e(),_c('a',{ref:"captchaButton",staticClass:"captchaButton",attrs:{"id":"captchaButton"}},[_vm._v("点击弹出验证窗口")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }